/** @format */

import PairingModelActionTypes from './pairing-model.types';
import dayjs from 'dayjs';

export const setPairingModelParameters = (parameters) => {
  if (parameters.start_date) {
    console.log(parameters.start_date);
    parameters.start_date = dayjs(parameters.start_date).format('YYYY-MM-DD');
  }

  if (parameters.end_date) {
    parameters.end_date = dayjs(parameters.end_date).format('YYYY-MM-DD');
  }
  return {
    type: PairingModelActionTypes.SET_PAIRING_MODEL_PARAMETERS,
    payload: parameters,
  };
};

export const setPairingModelCrewCount = (crew_count) => {
  return {
    type: PairingModelActionTypes.SET_PAIRING_MODEL_CREW_COUNT,
    payload: crew_count,
  };
};

export const setPairingModelError = (error) => {
  return {
    type: PairingModelActionTypes.SET_PAIRING_MODEL_ERROR,
    payload: error,
  };
};

export const setPairingModelRuntime = (runtime) => {
  return {
    type: PairingModelActionTypes.SET_PAIRING_MODEL_RUNTIME,
    payload: runtime,
  };
};

export const setPairingModelLoading = (loading) => {
  return {
    type: PairingModelActionTypes.SET_PAIRING_MODEL_LOADING,
    payload: loading,
  };
};

export const setSelectedPairingModel = (model) => {
  return {
    type: PairingModelActionTypes.SET_SELECTED_PAIRING_MODEL,
    payload: model,
  };
};

export const runPairingModelStart = () => {
  return {
    type: PairingModelActionTypes.RUN_PAIRING_MODEL_START,
  };
};

export const runPairingModelSuccess = (data) => {
  return {
    type: PairingModelActionTypes.RUN_PAIRING_MODEL_SUCCESS,
    payload: data,
  };
};

export const runPairingModelFailure = (error) => {
  return {
    type: PairingModelActionTypes.RUN_PAIRING_MODEL_FAILURE,
    payload: error,
  };
};

export const getPairingModelAvailableModelsStart = () => {
  return {
    type: PairingModelActionTypes.GET_PAIRING_MODEL_AVAILABLE_MODELS_START,
  };
};

export const getPairingModelAvailableModelsSuccess = (data) => {
  return {
    type: PairingModelActionTypes.GET_PAIRING_MODEL_AVAILABLE_MODELS_SUCCESS,
    payload: data,
  };
};

export const getPairingModelAvailableModelsFailure = (error) => {
  return {
    type: PairingModelActionTypes.GET_PAIRING_MODEL_AVAILABLE_MODELS_FAILURE,
    payload: error,
  };
};

export const getSelectedPairingModelDataStart = () => {
  return {
    type: PairingModelActionTypes.GET_SELECTED_PAIRING_MODEL_DATA_START,
  };
};

export const getSelectedPairingModelDataSuccess = (data) => {
  return {
    type: PairingModelActionTypes.GET_SELECTED_PAIRING_MODEL_DATA_SUCCESS,
    payload: data,
  };
};

export const getSelectedPairingModelDataFailure = (error) => {
  return {
    type: PairingModelActionTypes.GET_SELECTED_PAIRING_MODEL_DATA_FAILURE,
    payload: error,
  };
};

export const clearSelectedPairingModelData = () => {
  return {
    type: PairingModelActionTypes.CLEAR_SELECTED_PAIRING_MODEL_DATA,
  };
};
